<template>
  <div :class="{'info-box': true, 'searchInputOpen': getSearchInputState}" v-if="!getShowResultBox && checkPercent">
    <div class="loading-box" v-if="loading">
      <Loader color="white"/>
    </div>

    <div class="top-row">
      <div class="title-box" v-if="!loading">
        Your account limit is close:
      </div>
    </div>

    <div class="bottom-row">
      <div class="dialog-counter" v-if="!loading" title="Dialogs Counter">
        <div class="icon-box">
          <font-awesome-icon :icon="['fas', 'stream']" class="icon" />
        </div>
        <div class="value">{{ `${stats.stats.dialogNumber}/${stats.stats.dialogLimit}` }}</div>
      </div>
      <div class="recordings-counter" v-if="!loading" title="Recordings Counter">
        <div class="icon-box">
          <font-awesome-icon :icon="['fas', 'play-circle']" class="icon" />
        </div>
        <div class="value">{{ `${stats.stats.recordingsNumber}/${stats.stats.recordingsLimit}` }}</div>
      </div>
      <div class="upgrade-box" v-if="!loading">
        <button>
          <div class="long-text" @click="onUpgrade">Upgrade your subscription!</div>
          <div class="short-text" @click="onUpgrade">Upgrade!</div>
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import Loader from '@/components/Loader'

export default {
  name: 'InfoBox',
  props: {
    refresh: Number
  },
  data() {
    return {
      loading: false,
      stats: {}
    }
  },
  components: {
    Loader
  },
  methods: {
    loadUserStats() {
      this.loading = true;
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}loadUserStats`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
      }).then(result => {
        this.stats = result.data.stats;
        this.loading = false;
      }).catch(err => {
        console.log(err);
        this.loading = false;
      })
    },
    onUpgrade() {
      this.$router.push('/account');
    }
  },
  computed: {
    ...mapGetters('main', ['getShowResultBox', 'getSearchInputState']),
    checkPercent() {
      if(this.stats.stats) {
        if(this.stats.stats.dialogNumber / this.stats.stats.dialogLimit >= 0.8 || this.stats.stats.recordingsNumber / this.stats.stats.recordingsLimit >= 0.8) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  created() {
    this.loadUserStats();
  },
  watch: {
    refresh() {
      this.loadUserStats();
    }
  }
}
</script>

<style lang="scss" scoped>
.info-box {
  width: 55rem;
  height: 8rem;
  display: flex;
  flex-direction: column;
  filter:drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.123));
  background-color: rgb(202, 202, 202);
  border-radius: 0.2rem;
  overflow: hidden;
  margin-bottom: 3rem;

  @media (max-width: 900px) {
    width: 100%;
    margin-bottom: 2rem;
  }
}

.searchInputOpen {
  @media (max-width: 875px) {
    display: none;
  }
}

.loading-box {
  height: 8rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.top-row {
  width: 100%;
  height: 3rem;
  display: flex;
}

.bottom-row {
  width: 100%;
  height: 5rem;
  display: flex;
}

.title-box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 2rem;
  padding-top: 0.8rem;
  font-size: 1.3rem;
  font-weight: bold;
  @media (max-width: 550px) {
    padding-left: 1rem;
  }
  @media (max-width: 550px) {
    padding-left: 0.7rem;
    font-size: 1.2rem;
  }
  @media (max-width: 300px) {
    padding-left: 0.7rem;
    font-size: 1rem;
  }
}

.dialog-counter {
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .icon-box {
    .icon {
      font-size: 1.5rem;
      @media (max-width: 400px) {
        font-size: 1.2rem;
      }
    }
  }
  .value {
    font-size: 1.3rem;
    font-weight: bold;
    margin-left: 0.8rem;
    @media (max-width: 400px) {
      font-size: 1.2rem;
    }
  }
}
.recordings-counter {
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .icon-box {
    .icon {
      font-size: 1.6rem;
      @media (max-width: 400px) {
        font-size: 1.2rem;
      }
    }
  }
  .value {
    font-size: 1.3rem;
    font-weight: bold;
    margin-left: 0.8rem;
    @media (max-width: 400px) {
      font-size: 1.2rem;
    }
  }
}
.upgrade-box {
  flex: 2;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 650px) {
    flex: 1.5;
  }
  @media (max-width: 350px) {
    display: none;
  }

  button {
    background-color: #ebc659;
    border: 2px solid #c0a246;
    border-radius: 0.3rem;
    outline: none;
    width: 80%;
    height: 3rem;
    font-size: 1.1rem;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.2s;

    &:hover {
      cursor: pointer;
      background-color: #ddbb54;
    }

    @media (max-width: 400px) {
      height: 2.5rem;
      font-size: 1rem;
    }
  }

  .long-text {
    display: flex;
    @media (max-width: 650px) {
      display: none;
    }
  }

  .short-text {
    display: none;
    @media (max-width: 650px) {
      display: flex;
    }
  }
}
</style>